/**
 * Centered "[CLICK ANYWHERE]" hint shown while playing whenever pointer-lock
 * input is not engaged — e.g. at scenario start before the first canvas click,
 * or after the browser releases lock on Esc. Clicking the canvas re-engages
 * pointer lock (see {@link Controller}) and dismisses the prompt.
 *
 * Styled to match the transient command-feedback badge; visibility is driven
 * each frame from {@link update} (CSS handles the opacity transition).
 */
export default class ClickPrompt {
  constructor() {
    const el = document.createElement('div');
    el.id = 'click-prompt';
    el.textContent = '[CLICK ANYWHERE]';
    this.el = el;
    document.getElementById('app').appendChild(el);
  }

  /** @param {boolean} visible — show the prompt this frame. */
  update(visible) {
    this.el.classList.toggle('is-visible', visible);
  }

  dispose() {
    this.el.remove();
  }
}
